import React from "react";
import { useSector } from "./SectorContext";
import { useNavigate } from "react-router-dom";


function CyberPortfolioSection() {
  const { activeSector, openProject } = useSector();

  const projects = activeSector.projects;
  const navigate = useNavigate();

  return (
    <section className="cyber-portfolio-section">
      <div className="cyber-portfolio-wrapper">
        <div className="cyber-portfolio-heading">
          <h2 className={activeSector.colorClass}>@Latest Exploits</h2>
        </div>
        <div className="cyber-projects-container">
          {/*Map project data to project tiles. */}
          {projects.map((project, index) => (
            <div
            key={project.projName}
              className={`cyber-project-tile ${activeSector.colorClass}`}
              onClick={() => {openProject(project); navigate("/project")}}
            >
              
              <div className="cyber-project-tile-inner"> 
                <div className="cyber-project-headline">{project.projHeadline}</div>
                <div className="cyber-project-description">
                  {" "}
                  <p>{project.projOverview}</p>{" "}
                </div>
                <div className="cyber-project-thumbnail">
                  <img
                    src={project.projImages[0]}
                    alt={`${project.projName} project preview`}
                    loading="lazy"
                    decoding="async"
                  />
                  {/* <img src="jetimage.png" alt="project-thumbnail" /> */}
                </div>
              </div>
            </div>
          ))}
        </div>{" "}
      </div>
    </section>
  );
}

export default CyberPortfolioSection;
